import React, { useState } from "react";
import Cx from "classnames";

const { Configuration, OpenAIApi } = require("openai");

import WordCounter from "./WordCounter";
import styles from "./styles.scss";

const getLongDescription = () => {
  const el = document.querySelector("trix-editor[input=image_description]");

  return el ?
    el.textContent :
    "";
}

export default function AltTextGenerator({ apiKey }) {
  const [loading, setLoading] = useState(false);
  const query = async (e) => {
    e.preventDefault();

    const description = getLongDescription();
    const altEl = document.querySelector("trix-editor[input=image_alt]");

    if (description.length < 50) {
      alert("Enter a long description of at least 25 words before using this tool.");
      return;
    }

    if (altEl && altEl.textContent && !window.altTextGeneratorWarned) {
      const confirm = window.confirm("Alt text already exists. Overwrite with OpenAI-generated summary?\n\nNote: this tools works best with descriptions that are longer than approx. 30 words");
      window.altTextGeneratorWarned = true;
      if (!confirm) return;
    }

    if (!confirm) return;

    setLoading(true);

    const configuration = new Configuration({ apiKey });
    const openai = new OpenAIApi(configuration);
    const prompt = `Summarize this long image description into an alt text: ${description}`;

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt,
      temperature: 0.6,
      max_tokens: 30,
      frequency_penalty: 1.0,
    });
  
    const choice = response.data.choices[0].text;
    // remove incorrect formmating that is sometimes generated by OpenAI
    const cleanedUp = choice
      .replace(/alt text:?/i, "")
      .trim() // sometimes OpenAI returns \n\n"
      .replace(/\.$/, "")
      .replace(/^"+/, "")
      .replace(/"+$/, "")
      .trim();

    altEl.innerHTML = cleanedUp;
    const altInput = document.querySelector("input[name='image[alt]']");
    altInput.setAttribute("value", cleanedUp);
    setLoading(false);
  }

  return (
    <div className={Cx(styles.wrap, { [styles.loading]: loading })}>
      <WordCounter />
      <div className={styles.buttonWrap}>
        <button className={styles.button} onClick={query}>🪄</button>
      </div>
    </div>
  );
}